import { Section } from "design-system/molecules/Section"
import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { isWhatsappVisualTrigger } from "modules/campaigns/lib/configurationTabs"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CampaignDetailResponseDataSchema } from "schema"
import { z } from "zod"

import { WhatsappOpeningMessagesPicker } from "./templates/WhatsappOpeningMessagesPicker"

type Props = {
  isEditable: boolean
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
}

export function OpeningMessagesSubTab({ isEditable, campaign }: Props) {
  const { t } = useTranslation()
  const form = useFormContext<z.infer<typeof UpdateCampaignSchemaFrontend>>()
  const channel = form.watch("channel")
  const trigger = form.watch("trigger")

  if (!isWhatsappVisualTrigger(channel, trigger)) return null

  return (
    <Section
      title={t("campaigns.configuration.setup.config.whatsapp.title")}
      description={t("campaigns.configuration.setup.config.whatsapp.description")}
      className="gap-3"
    >
      <WhatsappOpeningMessagesPicker campaignId={campaign.id} isDisabled={!isEditable} />
    </Section>
  )
}
